import React from "react";
import CalendarHeader from "./CalendarHeader";
import CalendarRow from "./CalendarRow";

const Calendar = ({ timeSlots, visibleMembers, filteredLogs, members, selectedSlot, activeDate, onSelectSlot }) => (
  <div className="calendar">
    <CalendarHeader visibleMembers={visibleMembers} members={members} />
    {timeSlots.map(time => (
      <CalendarRow
        key={time}
        timeSlot={time}
        visibleMembers={visibleMembers}
        filteredLogs={filteredLogs}
        members={members}
        selectedSlot={selectedSlot}
        activeDate={activeDate}
        onSelectSlot={onSelectSlot}
      />
    ))}
  </div>
);

export default Calendar;
